import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
  LayoutAnimation,
  Platform,
} from "react-native";

import Icons from "../../common/icons";
import ActivityGroup from "./ActivityGroup";

export default function ActivitiesSets({
  sets = [],
  callback = () => {},
  initialNumToRender,
  title,
  hideCollapse = false,
  preSelected = false,
}) {
  const [setsList, setSetsList] = useState([]);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [message, setMessage] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    if (hasMoreItems && sets.length > initialNumToRender) {
      setSetsList(sets.slice(0, initialNumToRender));
      setMessage(`+ ${sets.length - initialNumToRender} more`);
    } else {
      setSetsList(sets.slice(0));
      setHasMoreItems(false);
    }
  }, [sets]);

  const showMore = () => {
    setSetsList(sets.slice(0));
    setHasMoreItems(false);
  };

  const toggleExpand = () => {
    if (hideCollapse) return;
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setIsCollapsed(!isCollapsed);
  };

  const toggleSelected = (selectedSet) => {
    setsList.forEach((s) => {
      if (s.id == selectedSet.id) {
        s.isSelected = !selectedSet.isSelected;
      }
    });

    const selectedSets = setsList.filter((s) => s.isSelected).map((s) => s.id);
    setTimeout(() => {
      callback({ sets: selectedSets, selectedSet });
    }, 10);
  };

  return (
    <View style={styles.mainContainer}>
      <TouchableOpacity onPress={toggleExpand}>
        {title ? <Text style={styles.header}>{title}</Text> : null}
        {!hideCollapse ? (
          <Icons.Collapse
            style={styles.collapseIcon}
            isCollapsed={isCollapsed}
          />
        ) : null}
      </TouchableOpacity>

      {!isCollapsed ? (
        <View style={styles.container}>
          {setsList.map((set, index) => (
            <ActivityGroup
              onPress={toggleSelected}
              key={`${set.id}-${set.isSelected ? 1 : 0}`}
              set={set}
              preSelected={preSelected}
            />
          ))}

          {hasMoreItems ? (
            <View style={styles.set}>
              <Icons.MoreItems
                showMore={showMore}
                message={message}
                hideArrow
              />
            </View>
          ) : null}
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    marginTop: 10,
  },
  header: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: "#2D3142",
    display: "flex",
    alignItems: "center",
    paddingLeft: 15,
  },
  container: {
    marginVertical: 10,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%",
    paddingHorizontal: 10,
  },
  set: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "46%",
    maxWidth: 168,
    height: 53,
    borderRadius: 5,
    margin: 4,
  },
});
